<div class="pageBox">
  <nz-pagination (nzPageIndexChange)="pageIndexChange($event)" (nzPageSizeChange)="pageSizeChange($event)"
                 [(nzPageIndex)]="page.pageNo" [nzTotal]="totals"
                 [nzShowSizeChanger]="showSizeChanger" [nzShowQuickJumper]="showQuickJumper"
                 [(nzPageSize)]="page.pageSize"></nz-pagination>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/page/page.component.html